import { useQuery } from '@apollo/client/react';
import { graphql } from '@/gql';
import { hasPermission } from '../../lib/permissions';
import { useSession } from './useSession';

export const ActiveRecognitionDayDoc = graphql(/* GraphQL */ `
  query ActiveRecognitionDay {
    activeRecognitionDay {
      id
      recognitionDate
      isOpen
      openedAt
      closedAt
    }
  }
`);

/**
 * Whether the current scope has an open recognition (trading) day.
 * null while loading or when the actor cannot read the field.
 *
 * Live open/close is written into this query's Apollo cache by
 * `useLiveEvents` when the `recognitionDay` arm of `liveUpdated` arrives.
 */
export function useRecognitionDayOpen(): boolean | null {
  const { me, loading: sessionLoading } = useSession();
  const scopeId = me?.currentScope?.id;
  const canRead = hasPermission(me?.permissions, 'scope:read');

  const { data, loading } = useQuery(ActiveRecognitionDayDoc, {
    skip: !scopeId || !canRead,
  });

  if (!canRead) {
    // Without scope:read we cannot know; apply idle logout (safer for scale-to-zero).
    return false;
  }
  if (sessionLoading || (!scopeId && !sessionLoading)) {
    return null;
  }
  if (loading && data === undefined) {
    return null;
  }
  return data?.activeRecognitionDay?.isOpen === true;
}
